module.exports = __webpack_public_path__ + "img/icon-compass.2a3f0506.svg";